import { Recapt } from '../engine';
import { RequestManager } from '../managers/requestManager';
import { SESSION_TAGS_STORAGE_KEY } from '../managers/storageConstants';
import { StorageManager } from '../managers/storageManager';
import { BaseEvent, BaseModule } from './base';
import { Namespace } from './types';

interface TagEvent extends BaseEvent {
  tag: string;
}

export class TagModule extends BaseModule<TagEvent> {
  public namespace: Namespace = 'tags';
  private tagsUsed: string[] = [];

  onTag(_tag: string) {
    const tag = _tag.trim();
    if (tag.length > 42) return;

    if (this.tagsUsed.includes(tag)) return;

    this.tagsUsed.push(tag);

    StorageManager.setItem(
      SESSION_TAGS_STORAGE_KEY,
      JSON.stringify(this.tagsUsed),
    );

    RequestManager.potentialPainpoint();

    this.state.push({
      timestamp: Recapt.getCurrentSessionTimestamp(),
      tag,
      where: Recapt.where(),
    });
  }

  onNewSession(): void {
    super.onNewSession();
    StorageManager.removeItem(SESSION_TAGS_STORAGE_KEY);
  }

  onStart() {
    const stored = this.loadStore<{
      state: TagEvent[];
    }>();

    if (stored) {
      this.state = stored.state;
    }

    this.store(() => ({
      state: this.state,
    }));

    this.tagsUsed = [];

    //we dont want duplicate of tags, even if we run recapt without .persist()
    const savedTags = StorageManager.getItem(SESSION_TAGS_STORAGE_KEY);

    if (savedTags) {
      const parsed = JSON.parse(savedTags);
      if (
        parsed &&
        Array.isArray(parsed) &&
        parsed.every((t) => typeof t === 'string')
      ) {
        this.tagsUsed = parsed;
      }
    }
  }

  onResume(): void {}

  onStop() {}

  purgeState(): void {
    this.state = [];
  }

  buildRequest(
    state: TagEvent[],
  ): Record<string, unknown> & { state: TagEvent[] } {
    return {
      state,
    };
  }
}
